import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import RootLoading from "../components/RootLoading/RootLoading";
import ScrollToTop from "../components/utils/ScrollToTop";
import Redirect from "./Redirect";
import pagesRoute from "./routes/pages";
import controlPanel from "./routes/controlPanel";
import { IRootState } from "..";
import Notification from "../components/Notification/Notification";

const Router = () => {
  const user = useSelector((state: IRootState) => state.user.value);
  const { loggedIn } = user;
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Notification />
      <Toaster />
      <Suspense fallback={<RootLoading />}>
        <Routes>
          {pagesRoute.map((route) => {
            if (
              route.meta.protectedRoute &&
              route.meta.role === "admin" &&
              loggedIn
            ) {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<route.component />}
                >
                  {controlPanel.map((cRoute) =>
                    cRoute.index ? (
                      <Route
                        key="index"
                        index
                        element={
                          <Suspense fallback={<RootLoading />}>
                            <cRoute.component />
                          </Suspense>
                        }
                      />
                    ) : (
                      <Route
                        key={cRoute.path}
                        path={cRoute.path}
                        element={
                          <Suspense fallback={<RootLoading />}>
                            <cRoute.component />
                          </Suspense>
                        }
                      />
                    )
                  )}
                </Route>
              );
            }
            if (route.meta.protectedRoute && !loggedIn) {
              return (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<Redirect redirectUrl={route.meta.redirectUrl} />}
                />
              );
            }

            return (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <route.component redirectUrl={route.meta.redirectUrl} />
                }
              />
            );
          })}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
